import * as generator from "./generator.jsx";
import * as enums from "./enums.jsx";
import keyboard from "./keyboard.jsx";
import resources from "./resources.jsx";
import gamepad from "./gamepad/index.jsx";
import loaders from "./loaders/index.jsx";
import math from "./math/index.jsx";
import * as obj from './obj/index.js'
export default {
  keyboard,
  resources,
  generator,
  enums,
  loaders,
  math,
  obj,
  gamepad,
};
